export const BACKEND_UNAVAILABLE_EVENT = 'auth:backend-unavailable';
export const BACKEND_AVAILABLE_EVENT = 'auth:backend-available';

export function notifyBackendUnavailable(): void {
  if (typeof window === 'undefined') return;
  if (!localStorage.getItem('token')) return;
  window.dispatchEvent(new CustomEvent(BACKEND_UNAVAILABLE_EVENT));
}

export function notifyBackendAvailable(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(BACKEND_AVAILABLE_EVENT));
}
